import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TemporaryStorageService {
  private _selectedFile: File | null = null;

  set selectedFile(file: File | null) {
    this._selectedFile = file;
  }

  get selectedFile(): File | null {
    return this._selectedFile;
  }

  clear() {
    this._selectedFile = null;
  }
}
